
import { Component, Prop, Vue } from "vue-property-decorator"

@Component({})
export default class InfoButton extends Vue {
  @Prop({ default: () => 16 }) public size!: number
}
